module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/normalize-wheel/index.js
// module id = 403
// module chunks = 17